import React, { useState, useEffect } from "react";
import "./nurseroster.css"; // External CSS file
import axios from "axios";
import { APIURL } from "../../Global";
import { useAlert } from "react-alert";
import "simplebar-react/dist/simplebar.min.css";
import { Modal, ModalTitle } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';
const AddRoster = (props) => {
    const [formData, setFormData] = useState({
        min_no_nurses: 0,
        total_nurses: 0,
        total_patients: 0,
        shifts_per_day: 2,
        start_time: "07:00:00",
        start_date: ''
    });
    const [leaveData, setLeaveData] = useState([]);
    const [nurses, setNurses] = useState([]);
    const [nursesRoster, setNursesRoster] = useState([]);
    const [dates, setDates] = useState([]);
    const alert = useAlert();

    useEffect(() => {
        const fetchLeaveDetails = async () => {
            try {
                const tokenString = sessionStorage.getItem("usertoken");
                const v2 = tokenString?.replace(/["]+/g, "");
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: "Token " + v2,
                };

                const start = new Date(formData.start_date);
                const end = new Date(start);
                end.setDate(start.getDate() + 28);

                const formatDate = (date) => {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    return `${year}-${month}-${day}`;
                };

                const formattedStart = formatDate(start);
                const formattedEnd = formatDate(end);

                // Fetch leave details
                const leaveDetails = await axios.get(
                    `${APIURL}/api/v1/service-provider/nurse-total-leave/?start_date=${formattedStart}&end_date=${formattedEnd}`,
                    { headers }
                );

                if (leaveDetails.data.status === "success") {
                    setLeaveData(leaveDetails.data.leaves || []);
                }
            } catch (error) {
                console.error("Error fetching leave details:", error);
            }
        };

        if (formData.start_date) {
            fetchLeaveDetails();
        }
        const generateDates = () => {
            const startDate = new Date(formData.start_date);
            const endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + 28)
            const datesArray = [];
            let currentDate = startDate;
            while (currentDate <= endDate) {
                datesArray.push(currentDate.toISOString().split("T")[0]); // Format as YYYY-MM-DD
                currentDate.setDate(currentDate.getDate() + 1);
            }
            setDates(datesArray);
        };

        generateDates()
    }, [formData.start_date]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenString = sessionStorage.getItem("usertoken");
                const v2 = tokenString?.replace(/["]+/g, "");
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: "Token " + v2,
                };

                const [rosterPreDetails, nurseDetails] = await Promise.all([
                    axios.get(`${APIURL}/api/v1/service-provider/roster-predetails/`, { headers }),
                    axios.get(`${APIURL}/api/v1/service-provider/nurse/`, { headers }),
                ]);

                if (rosterPreDetails.data.status === "success") {
                    setFormData((prevData) => ({
                        ...prevData,
                        min_no_nurses:rosterPreDetails.data.min_no_nurses || "",
                        total_nurses: rosterPreDetails.data.total_nurses || "",
                        total_patients: rosterPreDetails.data.total_patients || "",
                    }));
                }

                const filteredNurses = nurseDetails.data.filter((nurse) => nurse.username);
                setNurses(filteredNurses);

            } catch (error) {

            }
        };
        fetchData();

    }, []);

    const generateRoster = () => {
        const shiftNames = generateShiftNames(formData.start_time, formData.shifts_per_day);

        if (!shiftNames.length) {
            alert.error("Shift generation failed. Please check shift settings.");
            return;
        }

        // Pre-assign each nurse to a specific shift
        const nurseShiftMap = {};
        nurses.forEach((nurse, index) => {
            const shiftIndex = index % shiftNames.length; // Assign shift based on index
            nurseShiftMap[nurse.name] = shiftNames[shiftIndex]; // Map nurse to a shift
        });

        // Initialize 7-day roster
        const weeklyRoster = dates.slice(0, 7).map((date) => {
            const availableNurses = nurses.filter((nurse) => {
                const leave = leaveData.find(
                    (leave) => leave.nurse === nurse.name && leave.leave_days?.some((ld) => ld.date === date)
                );
                return !leave; // Nurse is available if not on leave
            });

            // Create daily shift assignments based on pre-assigned shifts
            const dailyShiftAssignments = shiftNames.map(() => []); // Initialize arrays for each shift
            availableNurses.forEach((nurse) => {
                const assignedShift = nurseShiftMap[nurse.name]; // Get nurse's assigned shift
                const shiftIndex = shiftNames.indexOf(assignedShift); // Get shift index
                if (shiftIndex >= 0) {
                    dailyShiftAssignments[shiftIndex].push(nurse);
                }
            });

            // Mark shifts with status (assigned or unassigned)
            const shiftStatus = dailyShiftAssignments.map((assignment) =>
                assignment.length > 0 ? "Assigned" : "Unassigned"
            );

            return { date, dailyShiftAssignments, shiftStatus };
        });

        // Replicate 7-day roster to form 28-day roster
        const fullRoster = [];
        for (let i = 0; i < 4; i++) {
            const startIndex = i * 7;
            weeklyRoster.forEach((weekDayRoster, idx) => {
                const newDate = new Date(dates[0]);
                newDate.setDate(newDate.getDate() + startIndex + idx);
                fullRoster.push({
                    date: newDate.toISOString().split("T")[0],
                    dailyShiftAssignments: weekDayRoster.dailyShiftAssignments,
                    shiftStatus: weekDayRoster.shiftStatus,
                });
            });
        }

        // Build final nurse roster
        const finalRoster = nurses.map((nurse) => {
            const shifts = dates.map((date) => {
                const leave = leaveData.find(
                    (leave) => leave.nurse === nurse.name && leave.leave_days?.some((ld) => ld.date === date)
                );

                if (leave) {
                    const leaveType = leave.leave_days.find((ld) => ld.date === date)?.leave_type;
                    return { date, status: leaveType === "week_off" ? "Off" : "Leave", shift: "" };
                }

                // Ensure fullRoster has a matching entry for the date
                const rosterEntry = fullRoster.find((r) => r.date === date);

                if (!rosterEntry) {
                    return { date, status: "N/A", shift: "" }; // Fallback if no roster entry exists
                }

                // Get the nurse's assigned shift
                const assignedShift = nurseShiftMap[nurse.name];
                const shiftIndex = shiftNames.indexOf(assignedShift);

                return shiftIndex >= 0
                    ? { date, status: `Assigned`, shift: assignedShift }
                    : { date, status: "N/A", shift: "" };
            });

            return { nurse, shifts };
        });

        setNursesRoster(finalRoster);
        console.log(finalRoster);
    };

    const generateShiftNames = (startTime, shiftsPerDay) => {
        if (!startTime || shiftsPerDay <= 0) {
            console.error("Invalid start time or shifts per day");
            return [];
        }

        const baseTime = new Date(`1970-01-01T${startTime}Z`);
        const shiftNames = [];
        for (let i = 0; i < shiftsPerDay; i++) {
            const shiftStart = new Date(baseTime.getTime() + i * (24 / shiftsPerDay) * 60 * 60 * 1000);
            shiftNames.push(shiftStart.toISOString().split("T")[1].slice(0, 5)); // Format as HH:mm
        }
        return shiftNames.map((time, idx) => `Shift ${idx + 1} (${time})`);
    };

    const shiftNames = generateShiftNames(formData.start_time, formData.shifts_per_day);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const roster = () => {
        const tokenString = sessionStorage.getItem("usertoken");
        const v2 = tokenString?.replace(/["]+/g, "");

        const headers = {
            "Content-Type": "application/json",
            Authorization: "Token " + v2,
        };

        const shiftNamesWithTimes = generateShiftNames(formData.start_time, formData.shifts_per_day);

        const formattedRoster = nursesRoster.map(({ nurse, shifts }) => {
            return shifts.map((shift) => {
                const { date, shift: shiftType, status } = shift;

                // Extract the index of the shift type to get corresponding start and end times
                const shiftIndex = shiftNamesWithTimes.findIndex((name) => name === shiftType);
                const shiftStart = shiftIndex >= 0
                    ? shiftNamesWithTimes[shiftIndex].match(/\(([^)]+)\)/)[1]
                    : null;
                const shiftEnd = shiftIndex >= 0 && shiftIndex < shiftNamesWithTimes.length - 1
                    ? shiftNamesWithTimes[shiftIndex + 1].match(/\(([^)]+)\)/)[1]
                    : "07:00"; // End of last shift wraps around to next day's start

                // Assign shift types (day, evening, night) based on index
                const shiftCategory = ["Morning", "Evening", "Night"][shiftIndex % formData.shifts_per_day];

                // Prepare the shift data for posting
                const shiftData = {
                    nurse_id: nurse.user,
                    date: date,
                    shift_type: shiftCategory, // Leave or shift category
                    shift_start: status === "Assigned" ? `${shiftStart}:00` : "00:00:00", // Start time with seconds
                    shift_end: status === "Assigned" ? `${shiftEnd}:00` : "00:00:00", // End time with seconds
                    status: status,
                };

                return shiftData;
            });
        }).flat();

        const postData = { roster: formattedRoster };

        // Send the processed roster data to the API
        axios
            .post(`${APIURL}/api/v1/service-provider/nurse-roster/`, postData, { headers })
            .then((res) => {
                if (res.status === 200 && res.data.status === "success") {
                    alert.success("Successfully updated");
                    props.onHide();
                }
            })
            .catch((error) => {
                console.error("Error posting data:", error);
            });
    };

    return (
        <div className="app">
            <Modal show={true} centered size="lg" onHide={props.onHide}>
                <ModalHeader closeButton>
                    <ModalTitle style={{ fontSize: '18px', margin: 0 }}><b>Add roster</b></ModalTitle>
                </ModalHeader>
                <Modal.Body style={{ textAlign: "left", display: 'flex', flexDirection: 'column' }} >
                    <div style={{ padding: "20px", maxWidth: "900px", margin: "0 auto" }}>
                        <div style={{ width: "fit-content", marginLeft: "auto", marginBottom: "30px", textAlign: "right", display: "flex" }}>
                            <button
                                onClick={() => generateRoster()}
                                style={{
                                    margin: "10px",
                                    padding: "10px 20px",
                                    backgroundColor: "#2456AE",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                }}
                            >
                                Generate Preview
                            </button>
                            <button
                                onClick={() => roster()}
                                style={{
                                    margin: "10px",
                                    padding: "10px 20px",
                                    backgroundColor: "#2456AE",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "5px",
                                    fontSize: "16px",
                                }}
                            >
                                Create Roster
                            </button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "20px" }}>
                            <div style={{ alignSelf: "end" }}>
                                <label style={styles.label}>
                                    Start Date:
                                    <input
                                        type="date"
                                        name="start_date"
                                        value={formData.start_date}
                                        onChange={handleInputChange}
                                        style={styles.input}
                                    />
                                </label>
                            </div>

                            <div style={{ alignSelf: "end" }}>
                                <label style={styles.label}>
                                    Minimum Number of Nurses:
                                    <input
                                        type="number"
                                        name="min_no_nurses"
                                        value={formData.min_no_nurses}
                                        onChange={handleInputChange}
                                        style={styles.input}
                                        disabled
                                    />
                                </label>
                            </div>

                            <div style={{ alignSelf: "end" }}>
                                <label style={styles.label}>
                                    Total Nurses:
                                    <input
                                        type="number"
                                        name="total_nurses"
                                        value={formData.total_nurses}
                                        onChange={handleInputChange}
                                        style={styles.input}
                                        disabled
                                    />
                                </label>
                            </div>

                            <div style={{ alignSelf: "end" }}>
                                <label style={styles.label}>
                                    Total Patients:
                                    <input
                                        type="number"
                                        name="total_patients"
                                        value={formData.total_patients}
                                        onChange={handleInputChange}
                                        style={styles.input}
                                        disabled
                                    />
                                </label>
                            </div>

                            <div style={{ alignSelf: "end" }}>
                                <label style={styles.label}>
                                    Shifts Per Day:
                                    <input
                                        type="number"
                                        name="shifts_per_day"
                                        value={formData.shifts_per_day}
                                        onChange={handleInputChange}
                                        style={styles.input}
                                    />
                                </label>
                            </div>

                            <div style={{ alignSelf: "end" }}>
                                <label style={styles.label}>
                                    Start Time:
                                    <input
                                        type="time"
                                        name="start_time"
                                        value={formData.start_time}
                                        onChange={handleInputChange}
                                        style={styles.input}
                                    />
                                </label>
                            </div>
                        </div>

                        {nursesRoster.length > 0 && (
                            <table className="club-table" style={styles.table}>
                                <thead>
                                    <tr>
                                        <th style={styles.headerCell}>Date</th>
                                        {shiftNames.map((shift, idx) => (
                                            <th key={idx} style={styles.headerCell}>{shift}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {dates.map((date) => (
                                        <tr key={date}>
                                            <td style={styles.cell}>{date}</td>
                                            {shiftNames.map((shift, shiftIdx) => {
                                                // Map through nursesRoster and find the nurse with a shift on the current date and shift
                                                const nursesInShift = nursesRoster
                                                    .map(({ nurse, shifts }) => {
                                                        // Find the shift detail for the current date and shift
                                                        const shiftDetail = shifts.find((s) => s.date === date && s.shift === shift);
                                                        return shiftDetail ? { name: nurse.name, status: shiftDetail.status } : null;
                                                    })
                                                    .filter(Boolean); // Filter out null values if no shift matches

                                                const handleRemoveNurse = (nurseName) => {
                                                    console.log("Remove nurse function", nurseName);
                                                };

                                                const handleAddNurse = () => {
                                                    console.log("Add nurse function");
                                                };

                                                const cellStyle = {
                                                    ...styles.cell,
                                                    ...(nursesInShift.length ? styles.assigned : styles.unassigned),
                                                };

                                                return (
                                                    <td key={shiftIdx} style={cellStyle}>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <div style={{ gap: "5px", display: "flex", flexDirection: "column" }}>
                                                                {nursesInShift?.length > 0 ? nursesInShift.map(({ name, status }) => (
                                                                    <div key={name} className="nurse-item">
                                                                        <span style={{ textTransform: "capitalize" }}>{name}</span>
                                                                    </div>
                                                                )) : <label>Nil</label>}
                                                            </div>
                                                        </div>
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    );
};

const styles = {
    label: {
        display: "block",
        fontWeight: "bold",
        marginBottom: "8px",
        fontSize: "16px",
        color: "#333",
    },
    input: {
        width: "100%",
        padding: "8px",
        fontSize: "14px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        marginTop: "6px",
    },
    headerCell: {
        border: "1px solid #ccc",
        padding: "8px",
        backgroundColor: "#f5f5f5",
        textAlign: "center",
        fontWeight: "bold",
    },
    cell: {
        border: "1px solid #ccc",
        padding: "8px",
        textAlign: "center",
    },
    assigned: { backgroundColor: "#d4edda" },
    unassigned: { backgroundColor: "#f8d7da" }
};
export default AddRoster;
